//noinspection JSFileReferences
import index from './contentBlocks/index.js';

index.init();